const { __ } = wp.i18n;

function ButtonLinkSitioWeb({ link }) {

  return (
    <a href={link}
      target={link === '#' ? '' : '_blank'}
      className="wp-button-link has-icon is-underlined has-icon-after has-button-link-black-500-color icon-arrow-up-right"
      rel="noopener noreferrer">
      <span className="cta-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.92308 6H18M18 6V16.0769M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className="cta-title">
        { __('Sitio Web', 'bizum-website') }
      </span>
    </a>
  );

}

export default ButtonLinkSitioWeb;